import React from 'react';
import { Link } from 'react-router-dom';

const NutritionViewHistory = ({nutritionSummary, clientId, ...props}) => {

  const getNutritionNumbers = (summery) => {
    return `${summery?.plan} Plans,
      ${summery?.meal} meals,
      ${summery?.snack} snacks,
      ${summery?.water} water,
      ${summery?.drink} drink`
      .split('undefined').join('0')
  }

  return (
    <div className="nutrition-item nutrition-item-history">
      <i className="fas fa-carrot"></i>
      <div className="nutrition-info">
        <Link to={`${clientId}/nutrition-history`}>View Nutrition Log History</Link>
        <p>{getNutritionNumbers(nutritionSummary)}</p>
      </div>
    </div>
  );
};

export default NutritionViewHistory;